import './woocommerce/scripts/index';
import './woocommerce/styles/index.scss';


// Theme shared components.
import './theme/scripts/components/addEventGtm.js';
import './shared/index.js'
